import { render } from "./DetailDriver.vue?vue&type=template&id=68571d74"
import script from "./DetailDriver.vue?vue&type=script&lang=js"
export * from "./DetailDriver.vue?vue&type=script&lang=js"

import "./DetailDriver.vue?vue&type=style&index=0&id=68571d74&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__